import Vue from 'vue'
import Vuex from 'vuex'
// import post from './modules/get'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    // post
  }
})
